import { colors } from "@dotnet/telematics-design-system";

export const generateDataTypeIconBackground = (props: any) =>
  props.disabled ? colors.gray50 : colors.gray100;

export const generateDataTypeIconColor = (props: any) =>
  props.disabled ? colors.gray200 : colors.textPlaceholder;
